<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>

    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/web/assets/images/aeroviewer-home.jpg"
             data-bg-overlay="#333" data-overlay-opacity="0.5"
    >
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">
                    <b>Privacy Policy</b>
                </h1>
                <br>
            </div>
        </div>
    </section>

    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container text-center">
            <div class="row">
                <div class="col">
                    <h1 class="block-title m-b-0">GDPR PRIVACY POLICY
                    </h1>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->

    <section class="p-b-40 p-t-10 sm-p-b-0">
        <div class="container">
            <div class="col">
                <div>
                    <p>
                        This Privacy Policy – Policy for the Protection of Personal Data is a part
                        of the Terms of Use of this Website and regulates the management and
                        protection of personal data of any user, always combined with the
                        provisions of national, European and international law with regard to
                        the protection of individuals from the processing of personal data, as in
                        force. Geotag Aeroview is committed to protecting and respecting
                        your privacy.
                    </p>
                    <strong>COLLECTION AND USE OF INFORMATION</strong>
                    <p>
                        Each user may browse the Website without providing any personal
                        information or data.
                        Geotag Aeroview collects personal data of the users of the Website
                        only when they voluntarily provide them in order to receive the services
                        which are available on line and where requested. Personal data are
                        data that can be used to determine the identity or communicating
                        with a person as well as other information related to same person.
                        Personal data that may be collected on this Website may include,
                        without limitation, the following:
                    </p>
                    <ul>
                        <li>Full name</li>
                        <li>Identity and / or VAT registration number</li>
                        <li>Occupation and /or position in a company</li>
                        <li>Address and phone number</li>
                        <li>Email address</li>
                    </ul>
                    <p>
                        Geotag Aeroview shall not make available for sale or otherwise
                        transmit or disclose personal data of the users of this Website to third
                        parties, not related to it, without the user’s consent.
                        Exceptionally, Geotag Aeroview may disclose personal data of the
                        users of the Website in the following cases:
                    </p>
                    <ul>
                        <li>When it has obtained the explicit consent of the user for the
                            disclosure, in any way, of their personal data.
                        </li>
                        <li>When the disclosure is made to third individuals or legal entities
                            with which it Geotag Aeroview cooperates and strictly and only to the
                            extent necessary for the provision of a service of this Website.
                        </li>
                        <li>If and when required by law, by a court decision or if and when
                            requested by any other government or regulatory authority.
                        </li>
                    </ul>
                    <p>
                        Geotag Aeroview may process part of all the information sent by users
                        for statistical reasons and to improve the services – information
                        provided in this Website.
                        The user may contact the administrator of the Website to check for the
                        existence of his/her personal file, to correct it, to change it or delete it,
                        at info@geotagaeroview.com. In this e-mail address the user can also
                        report any unlawful use of his/her personal data.
                        Geotag Aeroview puts its best efforts and has taken all measures so
                        that the users’ fundamental rights under GDPR be protected. Geotag
                        Aeroview has implemented appropriate technical and organisational
                        measures, in an effective way, in order to meet the requirements of the
                        EU General Data Protection Regulations (GDPR)and protect the rights
                        of data subjects'. It holds and processes only the data absolutely
                        necessary for the completion of its duties (data minimisation), as well as
                        limiting the access to personal data to those needing to act out the
                        processing.
                        The users’ have at any time the following rights:
                    </p>
                    <ol>
                        <li>
                            The right to be informed – all organisations must be completely
                            transparent in how they are using personal data (personal data may
                            include data such as a work email and work mobile if they are specific
                            to an individual).
                        </li>
                        <li>
                            The right of access - individuals will have the right to know
                            exactly what information is held about them and how it is processed.
                        </li>
                        <li>
                            The right of rectification - individuals will be entitled to have
                            personal data rectified if it is inaccurate or incomplete.
                        </li>
                        <li>
                            The right to erasure - also known as 'the right to be forgotten', this
                            refers to an individual's right to having their personal data deleted or
                            removed without the need for a specific reason as to why they wish to
                            discontinue.
                        </li>
                        <li>
                            The right to restrict processing - an individual's right to block or
                            suppress processing of their personal data.
                        </li>
                        <li>
                            The right to data portability - this allows individuals to retain and
                            reuse their personal data for their own purpose.
                        </li>
                        <li>
                            The right to object - in certain circumstances, individuals are
                            entitled to object to their personal data being used. This includes, if a
                            company uses personal data for the purpose of direct marketing,
                            scientific and historical research, or for the performance of a task in the
                            public interest.
                        </li>
                        <li>
                            Rights of automated decision making and profiling . For example,
                            individuals can choose not to be the subject of a decision where the
                            consequence has a legal bearing on them, or is based on automated
                            processing.
                        </li>
                    </ol>
                    <p>
                        If a user chooses to fill in a contact form on the website, Geotag
                        Aeroview will store that information for a period related to the service(s)
                        provided in accordance to the website’s terms of use and only use it
                        for the purpose of contacting you in relation to that enquiry.
                        When a user browses the website, Geotag Aeroview also automatically
                        receives his/her computer’s internet protocol (IP) address in order to
                        provide it with information that helps it learn about your browser and
                        operating system.
                        Email marketing: With the user’s explicit permission, Geotag Aeroview
                        may send emails about its products and other updates.
                        When a user provides Geotag Aeroview with personal information
                        he/she is asked to explicitly consent to such collecting it and using it for
                        that specific reason only.
                        If a user is asked for his/her personal information for a secondary
                        reason, like marketing, he/ she will either be asked directly for his/her
                        expressed consent, or be provided with an opportunity to say no.
                        If after the user’s opt-in, he/ she changes his/her mind, he/ she may
                        withdraw his/her consent for us to contact you, for the continued
                        collection, use or disclosure of your information, at anytime, by
                        contacting us at info@geotagaeroview.com.
                        All users’ data is stored through Geotag Aeroview’s data storage and
                        databases. It stores your data on a secure server behind a firewall.
                        To protect users’ personal information, Geotag Aeroview takes
                        reasonable precautions and follow industry best practices to make sure
                        it is not inappropriately lost, misused, accessed, disclosed, altered or
                        destroyed.When a user provides Geotag Aeroview with his/ her personal
                        information, the information is encrypted using secure socket layer
                        technology (SSL) and stored with industry-standard encryption.
                        Although no method of transmission over the Internet or electronic
                        storage is 100% secure, Geotag Aeroview implements generally
                        accepted industry standards.
                    </p>
                    <strong>COOKIES</strong>
                    <p>
                        Geotag Aeroview may obtain data of identification of the users of the
                        Website, by using relevant technologies, such as cookies or/and
                        monitoring Internet Protocol (IP) addresses.
                        Cookies are small text files stored on the hard drive of the user thus do
                        not access any document or file of the computer. They are used to
                        facilitate user’s access to specific services or/ and pages of the
                        Website, for statistical purposes and to determine the areas which are
                        useful or popular. These data may also include the type of browser
                        used by the user, the type of computer, its operating system, the
                        internet service provider and other such information. Additionally, the
                        information system of the Website automatically collects information
                        related to the sites its user visits and to the links on third party websites
                        that the user may select through the use of the Website.
                        Cookies are used for the following reasons, such as:
                    </p>
                    <ul>
                        <li>
                            To provide users with access to their personal services, through
                            entry into their account (login)
                        </li>
                        <li>
                            To provide personalized services to the users.
                        </li>
                        <li>
                            To record general data of the Website’s traffic.
                        </li>
                        <li>
                            To conduct research, for the improvement of the content and of
                            the services as well as for facilitating the user’s access to specific
                            services of the Website.
                        </li>
                        <li>
                            For the smooth operation of the services and of the pages of the
                            Website.
                        </li>
                        <li>
                            To display information to users based on their interests and
                            activities that they may have indicated during their registration.
                        </li>
                    </ul>
                    <p>
                        The user of the Website may set the program for surfing the Internet
                        (web browser) so as to be warned on the use of cookies on specificservices or to prevent the
                        acceptance of cookies in any case. Should
                        the user of these services not wish the use of cookies for his/her
                        identification, the user cannot have any further access to such
                        services.
                    </p>
                    <strong>
                        LINKS TO THIRD PARTIES’ SITES
                    </strong>
                    <p>
                        This Website contains links to other websites which are under the
                        responsibility of third parties (individuals or legal entities). Under no
                        circumstances is Geotag Aeroview liable for the terms of protection of
                        personal data these websites follow. Each user understands,
                        acknowledges and agrees that these links are provided solely for the
                        user’s convenience only and do not imply Geotag Aeroview
                        acceptance of their content and of the advertising or business
                        practices of any third parties. Geotag Aeroview is not liable for any
                        privacy policy or content of any such website, including sites which
                        indicate a special relationship or “partnership” with Geotag Aeroview.
                        Geotag Aeroview does not disclose the unique identification data to
                        the administrators of these websites for which there is a link. These
                        websites however, may collect personal data when users visit them.
                        This collection of information is not in Geotag Aeroview control. To
                        ensure privacy protection, users must always check the privacy policies
                        of the websites they visit and are provided as links on this Website.
                    </p>
                    <strong>
                        AMENDMENT OF PRIVACY POLICY
                    </strong>
                    <p>
                        Geotag Aeroview, as the Admistrator of this Website, always reserves
                        the right to update this Privacy Policy, in accordance with the
                        applicable legal framework. Therefore, this Policy may be revised at
                        any time and without notice. Users should periodically check the
                        Privacy Policy of the Website, as its continuous use implies that the user
                        accepts any amendments thereto, and therefore, the collection, use,
                        disclosure, management and storage of the users’ Personal Data as
                        described in this Policy, as in force.
                    </p>
                </div>
            </div>
        </div>
    </section>


    <!-- End section features -->

    <avr-footer></avr-footer>


    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/privacy-policy/app.tag.html